import * as React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { ThemeProvider, useTheme } from '../../../../../theme';
import Flight from '../../../../../Flight';
import { ExchangeRefundContentWrapper } from '@entities/order';
import { CdnIcon } from '@shared/ui';
const SelectedFlights = ({ className, selectedFlights, controls, hideHeader }) => {
    const { t } = useTranslation('Exchange');
    const { SelectedFlights: theme } = useTheme('Widgets').Exchange;
    return (React.createElement(ThemeProvider, { value: {
            Entities: {
                Order: {
                    ExchangeRefundContentWrapper: {
                        icon: theme.icon_selected,
                        header: cn({ [theme.hidden]: hideHeader })
                    }
                }
            },
            DesktopFlightRoute: {
                DesktopFlightRouteStyles: { container: theme.flight }
            },
            MobileFlight: {
                FlightStyles: { flight: theme.flight, readonly: theme.flight_readonly }
            },
            MobileSegmentInfo: {
                MobileSegmentFlat: { card: theme.flight__card, aircraft: theme.aircraft }
            }
        } },
        React.createElement(ExchangeRefundContentWrapper, { className: className, icon: React.createElement(CdnIcon, { icon: "Info/Choosed" }), title: t('SelectedFlights.Title'), controls: controls },
            React.createElement("div", { className: theme.flights }, selectedFlights.map((flight, index) => {
                var _a, _b;
                return (React.createElement(Flight, { key: flight.id, flight: Object.assign(Object.assign({}, flight), { pricesForFareGroups: [] }), isReturnFlight: ((_b = (_a = flight.segmentGroups) === null || _a === void 0 ? void 0 : _a[index]) === null || _b === void 0 ? void 0 : _b.groupId) === '1', isPreOpenAvailable: false, isPreOpen: false, hidePrice: true, readonly: true, isSelected: true }));
            })))));
};
export default SelectedFlights;
